var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';
import './Header';
import './Badges';
import { getApi } from '../../utils/fetcher';
import { BaseComponent } from '../../utils/BaseComponent';
import { trackEvent } from '../../utils/trackPulse';
import { formatScore } from '../../utils/scoreUtil';
import { SettingsController } from '../../utils/SettingsController';
import { userIdFromSdrn } from '../../utils/userUtils';
let Summary = class Summary extends BaseComponent {
    constructor() {
        super(...arguments);
        this.small = false;
        this._settingListener = new SettingsController(this, this.getData.bind(this));
    }
    async willUpdate(_changedProperties) {
        if (_changedProperties.has('user')) {
            await this.getData();
        }
    }
    async getData() {
        if (!this.user) {
            this._error = {};
        }
        else if (window.trustSettings) {
            const url = `/public/users/${this.user}/summary`;
            const { data: summaryResponse } = await getApi(url, window.trustSettings, this.overrideAccessToken) || {};
            if (summaryResponse) {
                this.summary = summaryResponse;
                if (!this._tracked) {
                    this._tracked = true;
                    trackEvent({
                        name: 'View trust summary',
                        intent: 'Show',
                        type: 'View',
                        position: this.position,
                    }, `${formatScore(summaryResponse.overallScore)}`, 'Trust summary', this.vertical, `${summaryResponse.numberOfReceivedFeedbacks}`);
                }
                this.requestUpdate();
            }
            else {
                this._error = {};
            }
        }
    }
    render() {
        if (!window.trustSettings)
            return nothing;
        if (this._error)
            return nothing;
        if (!this.summary)
            return nothing;
        if (this.summary.numberOfReceivedFeedbacks === 0) {
            return nothing;
        }
        const personProfileUrl = this.href && this.user ? this.href.replace('{{userId}}', userIdFromSdrn(this.user)) : undefined; // This does not work
        return html `
      <div class='p-16 rounded-lg bg-surface-primary'>
        <trust-summary-header href=${personProfileUrl} .summary='${this.summary}' ?small=${this.small}></trust-summary-header>
        ${this.summary.overallScore ? html `
          <ul class='mr-8 p-0 border-0 list-none'>
            ${this.summary.numberOfReceivedFeedbacks > 0 && this.summary.categoryScores.map(categoryScore => html `
                <trust-summary-badges ?small=${this.small} .categoryScore='${categoryScore}'></trust-summary-badges>
              `)}
          </ul>
        ` : nothing}
      </div>
    `;
    }
};
__decorate([
    property({ type: String })
], Summary.prototype, "user", void 0);
__decorate([
    property({ type: String })
], Summary.prototype, "href", void 0);
__decorate([
    property({ type: String })
], Summary.prototype, "position", void 0);
__decorate([
    property({ type: Object })
], Summary.prototype, "vertical", void 0);
__decorate([
    property({ type: Boolean })
], Summary.prototype, "small", void 0);
__decorate([
    state()
], Summary.prototype, "summary", void 0);
__decorate([
    property({ type: String })
], Summary.prototype, "overrideAccessToken", void 0);
Summary = __decorate([
    customElement('trust-summary')
], Summary);
export { Summary };
//# sourceMappingURL=Summary.js.map